/* eslint-disable react/no-danger */
/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable react/prefer-stateless-function */
import { Button, Grid } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useReactToPrint } from 'react-to-print';
// import html2pdf from 'html2pdf.js';
import './style.scss';
import { TypesBidPdfModal } from './types';
import { RootState } from '../../redux/rootState';
import ComponentToPrint from './components/ComponentToPrint';
import BidPdfEmailConfirmationModal from './components/BidPdfEmailConfirmationModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 3,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};

const getPageMargins = () => `
  @media print {
    @page {
      margin: 30px 10px 30px;
      size: A4;
    }

    body {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      background: white;
    }

    .printable-content {
      position: relative;
      padding: 0px;
      box-sizing: border-box;
      border: 4px double black;
      border-bottom: 0px;
    }

    .printable-content::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: -1px;
      border: 4px double black;
      pointer-events: none;
      z-index: -1;
      margin: 0;
    }
    tr, td, th {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
  }
`;

function PrintBidScreenComponent({
  show, setOpenFrom, comment,
}: TypesBidPdfModal) {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const { bidFieldsValue, bidTableData, bidPdfDetailsData } = useSelector((state: RootState) => state.bidPdfSliceReducer);
  const { userProfile } = useSelector((state: RootState) => state.userProfileReducer);
  const printRef = useRef(null);
  const pageMarginsCSS = getPageMargins();
  const handlePrint = useReactToPrint({
    content: () => printRef?.current,
    removeAfterPrint: true,
    copyStyles: true,
    documentTitle: `${bidPdfDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim()} (${bidPdfDetailsData?.QuoteNumber})`,
    // onBeforePrint: () => {
    //   document.title = `${bidPdfDetailsData?.SiteName} (${bidPdfDetailsData?.QuoteNumber})`;
    // },
  });
  // const handleDownloadPdf = async () => {
  //   const element = printRef.current;
  //   if (!element) return;

  //   try {
  //     // Wait for all images in the element to load
  //     // no need as we having static image
  //     // await waitForAllImagesToLoad(element);

  //     const opt = {
  //       margin: 0,
  //       filename: 'Bid_details.pdf',
  //       image: { type: 'jpeg' as const, quality: 0.6 },
  //       html2canvas: {
  //         backgroundColor: null,
  //         useCORS: true,
  //         scale: 2,
  //         allowTaint: false,
  //       },
  //       jsPDF: {
  //         unit: 'mm' as const,
  //         format: 'a4' as const,
  //         orientation: 'portrait' as const,
  //         compress: true,
  //       },
  //     };

  //     const worker = html2pdf().set(opt).from(element);
  //     const pdfBlob = await worker.outputPdf('blob');

  //     const pdfFile = new File([pdfBlob], 'Bid_PDF.pdf', { type: 'application/pdf' });

  //     // eslint-disable-next-line consistent-return
  //     return pdfFile;
  //   } catch (error) {
  //     // eslint-disable-next-line consistent-return
  //     return null;
  //   }
  // };

  return (
    <Modal
      open={show}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="div_job_container_info">
          <style>{pageMarginsCSS}</style>
          <ComponentToPrint
            className="print-area"
            comment={comment}
            userProfile={userProfile}
            bidFieldsValue={bidFieldsValue}
            bidTableData={bidTableData}
            ref={printRef}
            bidPdfDetailsData={bidPdfDetailsData}
          />
          <Grid item md={12} sm={12} xs={12}>
            <div className="save_and_next_div mt-2 me-3 ms-3">
              <div>
                <Button
                  onClick={setOpenFrom}
                  className="button_cancel"
                >
                  Cancel
                </Button>
              </div>
              <div className="button_margin_left">
                <Button
                  onClick={() => {
                    setShowEmailModal(true);
                  }}
                  className="sendEmailWPdfButton"
                >
                  Send Email
                </Button>
              </div>
              <div className="button_margin_left">
                <Button
                  onClick={() => {
                    handlePrint();
                  }}
                  className="printButton"
                >
                  Print
                </Button>
              </div>
            </div>
          </Grid>
        </div>
        <BidPdfEmailConfirmationModal
          show={showEmailModal}
          handleClose={() => setShowEmailModal(false)}
          // downloadPdf={handleDownloadPdf}
        />
      </Box>
    </Modal>
  );
}

export default PrintBidScreenComponent;
